module.exports = __webpack_public_path__ + "static/media/task-complete.749aa5cd.svg";